#content
<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId"></table-view>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import SearchView from './Search/Search';
import TableView from './Table/Table';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchView, TableView },
	methods: {
		refresh() {
			this.$refs.searchView.searchList();
		}
	}
};
</script>

<style></style>
